// src/components/RecipeCard.jsx
import React from "react";

const RecipeCard = ({ recipe }) => {
  const { name, category, servings, preparation_method } = recipe;
  const { size, temperature, ingredients = [] } = servings?.[0] || {};

  return (
    <div className="border rounded-lg p-4 bg-white shadow-md">
      <h2 className="text-xl font-bold mb-1">{name}</h2>
      <div className="text-gray-500 mb-2">{category}</div>

      <div className="text-sm text-gray-600 mb-2">
        <strong>Size:</strong> {size}{" "}
        {temperature && (
          <>
            <span>•</span> <strong>Temp:</strong> {temperature}
          </>
        )}
      </div>

      {ingredients.length > 0 && (
        <div className="mb-3">
          <div className="font-semibold">Ingredients</div>
          <ul className="list-disc pl-5 text-sm">
            {ingredients.map((ing, idx) => {
              if (typeof ing === "string") {
                return <li key={idx}>{ing}</li>;
              }
              if (typeof ing === "object") {
                const { amount, unit, name } = ing;
                return (
                  <li key={idx}>
                    {amount ? `${amount} ` : ""}
                    {unit ? `${unit} ` : ""}
                    {name || ""}
                  </li>
                );
              }
              return <li key={idx}>{String(ing)}</li>;
            })}
          </ul>
        </div>
      )}

      {preparation_method && (
        <div>
          <div className="font-semibold">Preparation</div>
          <ol className="list-decimal pl-5 text-sm">
            {preparation_method.steps?.map((step, i) => (
              <li key={i}>{step}</li>
            ))}
          </ol>
          {preparation_method.container && (
            <div className="italic text-xs mt-2 text-gray-500">
              Container: {preparation_method.container}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RecipeCard;
